export default __webpack_public_path__ + "static/media/rightArrow.78a0cf5b.svg";